import React from 'react'
import { FormControl, Select, MenuItem } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import stageFilterStyles from './stageFilter.styles'

const useStyles = makeStyles(stageFilterStyles)

const StageFilter = ({ stages, selectedStage, onStageChange, className }) => {
  const classes = useStyles()

  const handleChange = (event) => {
    const stageId = event.target.value
    const stage = stages?.find((s) => s.id === stageId)
    onStageChange(stage || null)
  }

  return (
    <FormControl className={`${classes.formControl} ${className}`}>
      <Select
        labelId='stage-filter-label'
        id='stage-filter'
        value={selectedStage?.id || ''}
        onChange={handleChange}
        displayEmpty
        disabled={!stages}
      >
        <MenuItem value=''>
          <em>All Stages</em>
        </MenuItem>
        {stages && stages.map((stage) => (
          <MenuItem key={stage.id} value={stage.id}>
            {stage.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default StageFilter
